
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal-login",
      function () {
        return require("private-next-pages/portal-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal-login"])
      });
    }
  